import { render } from "./index.vue?vue&type=template&id=5a8d3397&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5a8d3397&lang=less&scoped=true"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8d3397"]])

export default __exports__